export class Loader {

	get _api() {
		return window.Vimeo && window.Vimeo.Player;
	}

	request() {
		this._request = this._request || new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.charset = 'utf-8';
			script.async = true;
			script.defer = true;
			script.onerror = reject;
			script.onload = () => {
				this._api ?
					resolve(this._api) :
					reject(new Error('Vimeo api not found.'));
			};
			script.src = 'https://player.vimeo.com/api/player.js';
			document.head.appendChild(script);
		});

		return this._request;
	}

}
